<template>
  <vbt-dialog
    v-model="dialog"
    :title="title"
    width="700px"
    submit-btn-name="Change"
    @submit="submitForm"
    @close="$_resetFormAndValidation"
  >
    <v-form
      :ref="formRef"
      @submit.prevent="submitForm"
    >
      <ums-password-field v-model="form.password" />
    </v-form>
  </vbt-dialog>
</template>

<script>
import { useDialog, useFormWithRef } from '@mixins/factories';

import { wrapToLoadingFn } from '@helpers';

import UsersApiService from '../_services/users.api.service';

export default {
  name: 'UmsUserPasswordChanger',
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  mixins: [
    useDialog(),
    useFormWithRef(),
  ],
  data: () => ({
    form: { password: '' },
  }),
  computed: {
    title() {
      return `Change password for user '${this.user.name}'`;
    },
  },
  methods: {
    wrapToLoadingFn,
    submitForm() {
      if (!this.$_validateForm()) {
        return;
      }

      this.$VBlackerTheme.alert.warning({
        text: 'Change password?',
      }, () => this.wrapToLoadingFn({
        req: UsersApiService.changeUserPassword.bind({}, {
          id: this.user.id,
          password: this.form.password,
        }),
        onSuccess: () => {
          this.$VBlackerTheme.notification.success('Password successfully changed');
          this.$emit('success');
          this.$_closeDialog();
        },
      }));
    },
  },
};
</script>
